import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "portfolio-review",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "portfolio-review" */ "./components"),
      import(
        /* webpackChunkName: "portfolio-review" */ "./modules/PortfolioReviewModule"
      ),
      import(
        /* webpackChunkName: "course-journal" */ "Journal/modules/JournalModule"
      ),
      import(
        /* webpackChunkName: "course-journal" */ "Post/modules/PostModule"
      ),
    ])
      .then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const journal = importedModule2.default;
          const post = importedModule3.default;
          injectReducer(store, {
            key: "portfolioReview",
            reducer,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          injectReducer(store, {
            key: "journal",
            reducer: journal,
          });
          return component;
        }
      )
      .catch(err => {
        return err;
      })
  ),
});
